import React, { useEffect, useState } from 'react';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import { getOwnerAssets } from '@services/owner';

const Inventory = () => {
  const [nftColletion, setNftColletion] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const response = await getOwnerAssets();
      if (response?.nfts && response?.nfts?.result?.items.length > 0) {
        const findOwnerNft = response?.nfts?.result?.items.filter((nft) => nft.compression.compressed === true);
        if (findOwnerNft.length > 0) {

          const nfts = findOwnerNft.map((nft) => {
            const attributes = nft?.content?.metadata?.attributes || [];

            const timestampAttr = attributes.find(attr => attr.trait_type === 'timestamp');
            const cityAttr = attributes.find(attr => attr.trait_type === 'city');

            if (typeof timestampAttr?.value === 'string') {
              const value = new Date(timestampAttr);
              if (value instanceof Date && typeof timestampAttr?.value === 'string') {
                if (typeof cityAttr?.value === 'number') {
                  const timestamp = cityAttr.value;
                  cityAttr.value = timestampAttr.value;
                  timestampAttr.value = timestamp;
                } else {
                  const date = new Date(timestampAttr.value);
                  const timestamp = Math.floor(date.getTime() / 1000);
                  timestampAttr.value = timestamp;
                }
              } else {
                timestampAttr.value = cityAttr.value;
              }
            }

            return {
              ...nft,
            };
          });

          const finalNfts = filterAndSortNfts(nfts);
          setNftColletion(finalNfts);
          setLoading(false);
        }
      }
    };
    init();
  }, []);

  const filterAndSortNfts = (nfts) => {
    const withTimestampAndCity = nfts.filter((nft) => {
      const attributes = nft?.content?.metadata?.attributes || [];
      const timestampAttr = attributes.find(attr => attr.trait_type === 'timestamp');
      const cityAttr = attributes.find(attr => attr.trait_type === 'city');
      return timestampAttr && cityAttr;
    });

    const withoutTimestampAndCity = nfts.filter((nft) => {
      const attributes = nft?.content?.metadata?.attributes || [];
      const timestampAttr = attributes.find(attr => attr.trait_type === 'timestamp');
      const cityAttr = attributes.find(attr => attr.trait_type === 'city');
      return !timestampAttr && !cityAttr;
    });

    const sortedNfts = withTimestampAndCity.sort((a, b) => {
      const aTimestamp = a?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'timestamp')?.value;
      const bTimestamp = b?.content?.metadata?.attributes?.find(attr => attr.trait_type === 'timestamp')?.value;
      return bTimestamp - aTimestamp;
    });

    return [...sortedNfts, ...withoutTimestampAndCity];
  };


  return (
    <div className='flex items-start gap-[4px] w-full h-full'>
      <div className='overflow-y-scroll h-[100%] max-h-[95%] w-[23%] rounded-[32px]' style={{ background: `linear-gradient(180deg, rgba(119, 45, 139, 0.50) 0%, rgba(215, 53, 255, 0.00) 100%), rgba(250, 250, 250, 0.20)` }}>
        <LeftSection nftColletion={nftColletion} />
      </div>
      <div className='overflow-y-scroll h-[100%] max-h-[95%] w-[77%]'>
        <RightSection
          nftColletion={nftColletion}
          loading={loading}
        />
      </div>
    </div>
  )
}

export default Inventory